/**
 * CRM's `InvestmentModel.id` for Custom Holdings — the id `getAgentInvestmentModels`
 * returns. NOT the same number as Eclipse's, below: the two systems keep separate id
 * spaces for the same model and must never be cross-compared.
 */
export const customHoldingsModelID = 181;

/**
 * Orion Eclipse's `modelId` for Custom Holdings, used to pick the hand-traded sleeve
 * out of an account's `getAccountDetails` rows. Confirmed against three separate
 * sleeved accounts in this environment.
 *
 * The id is the primary discriminator because it survives both a rename and the
 * ~29-character truncation Eclipse applies to sleeve account numbers
 * (`45253535_Betashield Fundament`). {@link customHoldingsModelName} is the fallback
 * for an id drift between environments — see `findCustomHoldingsSleeve`, which
 * reports a disagreement rather than silently preferring one.
 */
export const customHoldingsEclipseModelID = 6;

/** Eclipse `model` name for the Custom Holdings sleeve. Never truncated by Orion. */
export const customHoldingsModelName = 'Custom Holdings';
